import React from 'react';
import PropTypes from "prop-types";
import {Popover} from "antd";

const Legend = ({ colors, categorisedFootprint}) => {
    const legend = (color, label, footprint, tooltipText) => <div>
        <span className="legend-dot" style={{ backgroundColor: color }}></span>
        <span style={{ paddingLeft: 5 }}>
            {!tooltipText ?
            label :
                <Popover className="popover-question" content={tooltipText} title={<b>{label}</b>}>
                <a>{label}</a>
                </Popover>
        
            }
            
            : </span>{footprint.toFixed(1)}t
    </div>

    return (<div className="d-flex flex-column justify-center">
        <div className="chart-legend left">
            {legend(colors[0], `Transport`, categorisedFootprint.Transport)}
        </div>
        <div className="chart-legend left">
            {legend(colors[1], `Energy`, categorisedFootprint.Energy)}
        </div>
        <div className="chart-legend left">
            {legend(colors[2], `Food`, categorisedFootprint.Food)}
        </div>
        <div className="chart-legend left">
            {legend(colors[4], `Other`, categorisedFootprint.Other)}
        </div>
        {/* <div className="chart-legend left">
            {legend(colors[3], `Country emissions`, categorisedFootprint.CountryEmissions)}
        </div> */}
    </div>);
}

Legend.propTypes = {
    colors: PropTypes.array.isRequired,
    footprint: PropTypes.object
};
 
export default Legend;